// ═══════════════════════════════════════════════════════════════════
// IEGlyph.js — the heart and the eyes as React elements (ieGlyphs.js is the art)
// MASTER COPY: gamemaster/engine/IEGlyph.js — vendored byte-identical, with ieGlyphs.js.
//   <IEGlyph kind="heart" size={40}/>   kind: "heart" | "heart-small" | "eyes" | "swirl" | "lux"
//   <KhaoMark/> · <LuxMark/> — inline, text-sized, take the surrounding text colour
// A row/tab `icon` may be the string "ie:heart" / "ie:eyes" and the band draws this.
// ═══════════════════════════════════════════════════════════════════
import { useId } from "react";
import { glyphSvg } from "./ieGlyphs";

export default function IEGlyph({ kind = "heart", size = 24, style = null, title = null }) {
  const k = kind === "heart" && size <= 26 ? "heart-small" : kind;
  // each drawing gets its own filter id — a shared id="ieSpray" breaks when the
  // first copy in the page sits in a hidden panel (review, 2026-10-21)
  const uid = useId().replace(/[^a-zA-Z0-9_-]/g, "");
  const svg = glyphSvg(k).replace(/ieSpray/g, "ieSpray" + uid);
  return (
    <span role={title ? "img" : undefined} aria-label={title || undefined} aria-hidden={title ? undefined : "true"}
      style={{ display: "inline-block", width: size, lineHeight: 0, verticalAlign: "middle", ...(style || {}) }}
      dangerouslySetInnerHTML={{ __html: svg }} />
  );
}
// "ie:heart" → <IEGlyph kind="heart"/>; any other string is drawn as text.
export function iconNode(icon, size = 20) {
  if (typeof icon === "string" && icon.startsWith("ie:")) return <IEGlyph kind={icon.slice(3)} size={size} />;
  return icon;
}

// Inline marks that sit IN a line of text (cost labels, counters): 1em wide,
// nudged onto the baseline, coloured by the text around them.
const inline = (size) => ({ width: size || "0.95em", verticalAlign: "-0.12em", marginRight: "0.08em" });
export function KhaoMark({ size = null, title = null }) { return <IEGlyph kind="swirl" size={size || "0.95em"} style={inline(size)} title={title} />; }
export function LuxMark({ size = null, title = null }) { return <IEGlyph kind="lux" size={size || "1em"} style={inline(size)} title={title} />; }
